/* tslint:disable */
/* eslint-disable */
/**
 * Optimizely Flags Scheduling API
 * This page documents how to use Optimizely Flags Scheduling API. These APIs allow you to turn a flag on/off, turn a  rule on/off, change the traffic allocation of a rule and change the audience conditions of a rule. 
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ApproversResponse,
    ApproversResponseFromJSON,
    ApproversResponseFromJSONTyped,
    ApproversResponseToJSON,
    EnvironmentApprovalSettingsCreateDefaultPreferences,
    EnvironmentApprovalSettingsCreateDefaultPreferencesFromJSON,
    EnvironmentApprovalSettingsCreateDefaultPreferencesFromJSONTyped,
    EnvironmentApprovalSettingsCreateDefaultPreferencesToJSON,
} from './';

/**
 * 
 * @export
 * @interface EnvironmentApprovalSettingsResponse
 */
export interface EnvironmentApprovalSettingsResponse {
    /**
     * The unique identifier for the schedule
     * @type {number}
     * @memberof EnvironmentApprovalSettingsResponse
     */
    id: number;
    /**
     * The project id where the environment belongs
     * @type {number}
     * @memberof EnvironmentApprovalSettingsResponse
     */
    project_id: number;
    /**
     * The environment id where action is happening
     * @type {number}
     * @memberof EnvironmentApprovalSettingsResponse
     */
    environment_id: number;
    /**
     * The setting\'s entity type
     * @type {string}
     * @memberof EnvironmentApprovalSettingsResponse
     */
    entity_type: string;
    /**
     * Denotes approval required status for new entities
     * @type {boolean}
     * @memberof EnvironmentApprovalSettingsResponse
     */
    require_approval_on_new_entities: boolean;
    /**
     * 
     * @type {EnvironmentApprovalSettingsCreateDefaultPreferences}
     * @memberof EnvironmentApprovalSettingsResponse
     */
    default_preferences?: EnvironmentApprovalSettingsCreateDefaultPreferences;
    /**
     * List of notification recipients associated with the environment approval settings
     * @type {Array<string>}
     * @memberof EnvironmentApprovalSettingsResponse
     */
    notification_recipients: Array<string>;
    /**
     * List of approvers
     * @type {Array<ApproversResponse>}
     * @memberof EnvironmentApprovalSettingsResponse
     */
    approvers: Array<ApproversResponse>;
    /**
     * 
     * @type {Array<object>}
     * @memberof EnvironmentApprovalSettingsResponse
     */
    entities: Array<object>;
    /**
     * Timestamp when the settings are created
     * @type {Date}
     * @memberof EnvironmentApprovalSettingsResponse
     */
    created_at: Date;
    /**
     * Timestamp when the settings are updated
     * @type {Date}
     * @memberof EnvironmentApprovalSettingsResponse
     */
    updated_at: Date;
}

export function EnvironmentApprovalSettingsResponseFromJSON(json: any): EnvironmentApprovalSettingsResponse {
    return EnvironmentApprovalSettingsResponseFromJSONTyped(json, false);
}

export function EnvironmentApprovalSettingsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): EnvironmentApprovalSettingsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'project_id': json['project_id'],
        'environment_id': json['environment_id'],
        'entity_type': json['entity_type'],
        'require_approval_on_new_entities': json['require_approval_on_new_entities'],
        'default_preferences': !exists(json, 'default_preferences') ? undefined : EnvironmentApprovalSettingsCreateDefaultPreferencesFromJSON(json['default_preferences']),
        'notification_recipients': json['notification_recipients'],
        'approvers': ((json['approvers'] as Array<any>).map(ApproversResponseFromJSON)),
        'entities': json['entities'],
        'created_at': (new Date(json['created_at'])),
        'updated_at': (new Date(json['updated_at'])),
    };
}

export function EnvironmentApprovalSettingsResponseToJSON(value?: EnvironmentApprovalSettingsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'project_id': value.project_id,
        'environment_id': value.environment_id,
        'entity_type': value.entity_type,
        'require_approval_on_new_entities': value.require_approval_on_new_entities,
        'default_preferences': EnvironmentApprovalSettingsCreateDefaultPreferencesToJSON(value.default_preferences),
        'notification_recipients': value.notification_recipients,
        'approvers': ((value.approvers as Array<any>).map(ApproversResponseToJSON)),
        'entities': value.entities,
        'created_at': (value.created_at.toISOString()),
        'updated_at': (value.updated_at.toISOString()),
    };
}


